import * as constants from "./../constants";
import { getVehicleNumberValues, getAvatarStringFromName,getDateInStringDDMMMYYYY, getVehicleNumberValuesDWeb } from "./utils/utils";
import { sumCalculation } from "../../utils/utils";
import * as logger from './../../logger';
export const getPNLExpenses = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/v2/user-org/reports/pnl",
    data,
    success: (response) => processProfitLossReport(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const getTotalMonthExpense = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/expenses/sparkline?month=${data.monthYear}`,
    success: (response) => processGetTotalMonthExpense(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const getTruckExpenses = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/expenses/truck?month=${data.monthYear}&&pageNo=${data.pageNo}&&pageSize=${data.pageSize}${data&&data.searchText?`&&searchText=${data.searchText}`:''}`,
    success: (response) => processGetTruckExpenses(response,data&&data.merge?data.merge:false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const getTripExpenses = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/expenses/trip?month=${data.monthYear}&&pageNo=${data.pageNo}&&pageSize=${data.pageSize}${data&&data.searchText?`&&searchText=${data.searchText}`:''}`,
    success: (response) => processGetTripExpenses(response,data&&data.merge?data.merge:false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const getOfficeExpenses = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/expenses/office?month=${data.monthYear}&&pageNo=${data.pageNo}&&pageSize=${data.pageSize}${data&&data.searchText?`&&searchText=${data.searchText}`:''}`,
    success: (response) => processGetOfficeExpenses(response,data&&data.merge?data.merge:false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
const processProfitLossReport = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_PNL_EXPENSES, payload: payloadData }
}
const processGetTotalMonthExpense = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_EXPENSES_SPARKLINE_DATA, payload: payloadData }
}
const processGetTruckExpenses = (response,merge) => {
  let payloadData = response.response;
  payloadData.merge=merge;
  if(payloadData&&payloadData.expenses&&payloadData.expenses.length>0){
    payloadData.totalMonthExpense = sumCalculation(payloadData.expenses,'amount')
  }
  return { type: constants.GET_TRUCK_EXPENSES_DATA, payload: payloadData }
}
const processGetTripExpenses = (response,merge) => {
  let payloadData = response.response;
  payloadData.merge=merge;
  if(payloadData&&payloadData.expenses&&payloadData.expenses.length>0){
    payloadData.totalMonthExpense = sumCalculation(payloadData.expenses,'amount')
  }
  return { type: constants.GET_TRIP_EXPENSES_DATA, payload: payloadData }
}
const processGetOfficeExpenses = (response,merge) => {
  let payloadData = response.response;
  payloadData.merge=merge;
  if(payloadData&&payloadData.expenses&&payloadData.expenses.length>0){
    payloadData.totalMonthExpense = sumCalculation(payloadData.expenses,'amount')
  }
  return { type: constants.GET_OFFICE_EXPENSES_DATA, payload: payloadData }
}
export const selectedJourney = (journey) => {
  return { type: constants.SELECT_JOURNEY, payload: journey }
}
export const addNewExpense = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
      method: "POST",
      url: `/vehicle/${data.type}/custom_expense_type`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
  }
});
export const addNewTripExpense = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
      method: "POST",
      url: `/trip/add_expense_type`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
  }
});
export const addNewOfficeExpenseType = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
      method: "POST",
      url: `/expenses/office/custom_expense_type`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
  }
});
export const addNewOfficeExpense = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
      method: "POST",
      url: `/expenses/office`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
  }
});
export const editOfficeExpense = (id,data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
      method: "PUT",
      url: `/expenses/office/${id}`,
      data,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
  }
});
export const deleteOfficeExpense = (id, onSuccess, onError) => ({
  type: constants.API,
  payload: {
      method: "DELETE",
      url: `/expenses/office/${id}`,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
  }
});
export const getOfficeExpenseSingle = (id, onSuccess, onError) => ({
  type: constants.API,
  payload: {
      method: "GET",
      url: `/expenses/office/${id}`,
      success: (response) => populateNoStateUpdate(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
  }
});
export const getAllVehicleExpense = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
      method: "GET",
      url: "/vehicle/all_expense_types",
      success: (response) => processVehicleExpenses(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
  }
});
export const processVehicleExpenses = (response) => {
  let payloadData = response.response;
  let list = [];
  if(payloadData && payloadData.length>0){
    for (const key in payloadData) {
      if (Object.hasOwnProperty.call(payloadData, key)) {
        const expenses = payloadData[key];
        if(expenses && expenses.expenses && expenses.expenses.length>0){
          for (const k in expenses.expenses) {
            if (Object.hasOwnProperty.call(expenses.expenses, k)) {
              const expense = expenses.expenses[k];
              list.push({
                ...expense,
                mapper:expenses.displayName,
                expenseParentType:expenses.key
              })
            }
          }
        }
      }
    }
  }
  return { type: constants.ALL_VEHICLE_EXPENSES, payload: list }
}
export const getAllTripExpenseTypes = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
      method: "GET",
      url: "/trip/expense_types",
      success: (response) => processTripExpenseTypes(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
  }
});
export const processTripExpenseTypes = (response) => {
  let payloadData = response.response;
  let list = [];
  if(payloadData){
    for (const key in payloadData) {
      if (Object.hasOwnProperty.call(payloadData, key)) {
        const expenses = payloadData[key];
        if(expenses && expenses.length>0){
          for (const k in expenses) {
            if (Object.hasOwnProperty.call(expenses, k)) {
              const expense = expenses[k];
              if(expense && expense.value && expense.value!='Vehicle_Hire_Cost')
                list.push({
                  ...expense,
                  mapper:key=='recentlyUsed'?'Recently Used':key=='recommended'?'Recommended':key,
                })
            }
          }
        }
      }
    }
  }
  return { type: constants.ALL_TRIP_EXPENSES, payload: list }
}
export const getAllOfficeExpenseTypes = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
      method: "GET",
      url: "/expenses/office/expense_types",
      success: (response) => processOfficeExpenseTypes(response),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
  }
});
export const processOfficeExpenseTypes = (response) => {
  let payloadData = response.response;
  let list = [];
  return { type: constants.ALL_OFFICE_EXPENSES_TYPES, payload: payloadData }
}
const populateNoStateUpdate= (response) => {
  return { type: null, payload: null };
}

export const getJourneys = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
      method: "POST",
      url: `/journeys`,
      data,
      success: (response) => processJourneys(response,data.merge?true:false),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
  }
});
export const processJourneys = (response,merge) => {
  let payloadData = response.response;
  payloadData.merge=merge;
  let trips = [];
  if(payloadData && payloadData.journeys && payloadData.journeys.length>0){
    for (const key in payloadData.journeys) {
      if (Object.hasOwnProperty.call(payloadData.journeys, key)) {
        const journey = payloadData.journeys[key];
        if(journey && journey.id && journey.trips && journey.trips.length>0){
          let prevTrip=null
          for (const k in journey.trips) {
            if (Object.hasOwnProperty.call(journey.trips, k)) {
                const trip = journey.trips[k];
                let newTrip = {
                  ...trip,
                  rowSpan:journey.totalTripCount,
                  journeyId:journey.id,
                  driver:journey.driver,
                  vehicle:journey.vehicle,
                  vendor:journey.vendor
                }
                if(journey.totalTripCount&&journey.totalTripCount>1){
                  newTrip.grouping=true
                  newTrip.groupClass=k==0?'firstCell':k==journey.totalTripCount-1?'lastCell':'middleCell'
                  /*if(!prevTrip){
                    newTrip.grouping=true
                  }else if(prevTrip && prevTrip.grouping){
                    newTrip.grouping=false
                  }if(prevTrip && !prevTrip.grouping){
                    newTrip.grouping=true
                  }*/
                }else{
                  newTrip.grouping=false
                }
                prevTrip = newTrip;
                trips.push(newTrip)
            }
          }
        }
      }
    }
  }
  payloadData.trips = trips;
  return { type: constants.GET_JOURNEYS, payload: payloadData }
}